export default {
  name: "FeaturesSection",

  data() {
    return ({
      features: [
        {
          key: "utilities",
          icon: "bi bi-droplet-fill",
          title: "Utilities",
          description: "Track water and electricity consumption across every property, in real time.",
        },
        {
          key: "energy",
          icon: "bi bi-lightning-charge-fill",
          title: "Energy",
          description: "Spot usage spikes and inefficiencies before they hit your bottom line.",
        },
        {
          key: "security",
          icon: "bi bi-shield-lock-fill",
          title: "Security",
          description: "Live incident feeds, access control status and response times in one place.",
        },
        {
          key: "connectivity",
          icon: "bi bi-wifi",
          title: "Connectivity",
          description: "Monitor uptime and network health across every connected site.",
        },
      ],
    });
  },
};
